import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FeaturedTool } from "@/data/featuredTools";

export default function Carousel({ tools }: { tools: FeaturedTool[] }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % tools.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [tools.length]);

  return (
    <div className="relative w-full h-[400px] overflow-hidden rounded-xl shadow-xl">
      {tools.map((tool, index) => (
        <div
          key={tool.id}
          className={`absolute inset-0 transition-opacity duration-1000 flex items-center ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={tool.imageUrl}
            alt={tool.name}
            className="absolute inset-0 w-full h-full object-cover filter brightness-50"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
          <div className="relative z-10 text-white p-8 max-w-2xl">
            <span className="inline-block bg-[var(--accent)] text-sm font-semibold px-4 py-2 rounded-full mb-4 shadow-lg">
              Featured Tool
            </span>
            <h2 className="text-4xl font-bold mb-3 drop-shadow-lg">{tool.name}</h2>
            <p className="text-xl mb-6 text-white drop-shadow-md leading-relaxed">{tool.description}</p>
            <Link
              to={`/tool/${tool.id}`}
              className="btn-primary inline-flex items-center"
            >
              View Details
              <i className="fa-solid fa-arrow-right ml-2"></i>
            </Link>
          </div>
        </div>
      ))}
      <div className="absolute bottom-6 left-0 right-0 flex justify-center space-x-2">
        {tools.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-12 h-1.5 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-white w-6" : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
  );
}